export const VALID_GUESSES = [
  'abbed',
  'abbor',
  'abrot',
  'accra',
  'addis',
  'adept',
  'adobe',
  'adolf',
  'advis',
  'aerob',
  'afasi',
  'afori',
  'aften',
  'agape',
  'agave',
  'agder',
  'agens',
  'agent',
  'agere',
  'agnat',
  'agnor',
  'agoni',
  'agora',
  'agrar',
  'agurk',
  'aires',
  'akaba',
  'aking',
  'akkar',
  'akper',
  'akryl',
  'aksel',
  'aksje',
  'aksle',
  'akter',
  'aktet',
  'aktin',
  'aktiv',
  'aktor',
  'aktre',
  'akutt',
  'alali',
  'alant',
  'alarm',
  'albin',
  'albue',
  'album',
  'alder',
  'aldre',
  'aldri',
  'alene',
  'aleut',
  'alger',
  'algol',
  'alias',
  'alibi',
  'aling',
  'alkan',
  'alken',
  'alkis',
  'alkyd',
  'alkyl',
  'alkyn',
  'allah',
  'allel',
  'aller',
  'almen',
  'alpin',
  'altan',
  'alter',
  'alvar',
  'alvor',
  'ambar',
  'ambra',
  'amdal',
  'amman',
  'amorf',
  'ampel',
  'amper',
  'amund',
  'anbud',
  'andel',
  'andra',
  'andre',
  'anemi',
  'angel',
  'anger',
  'angle',
  'angre',
  'angst',
  'aning',
  'anion',
  'anita',
  'ankel',
  'anker',
  'ankre',
  'annal',
  'annen',
  'anode',
  'anrop',
  'anton',
  'aorta',
  'apati',
  'aperi',
  'aping',
  'apoge',
  'april',
  'apsis',
  'areal',
  'arena',
  'argon',
  'argot',
  'arier',
  'arild',
  'arisk',
  'arkiv',
  'armod',
  'aroma',
  'arret',
  'arrig',
  'arsen',
  'artig',
  'arves',
  'arvid',
  'asdic',
  'asete',
  'asiat',
  'asker',
  'asket',
  'askim',
  'aslak',
  'aspik',
  'astat',
  'astma',
  'astri',
  'aswan',
  'athen',
  'atlas',
  'atlet',
  'atoll',
  'atoni',
  'atsjo',
  'atten',
  'atter',
  'attom',
  'attre',
  'atypi',
  'audun',
  'aufer',
  'augur',
  'auing',
  'aukra',
  'auret',
  'aurum',
  'austa',
  'autor',
  'avart',
  'avbud',
  'avdal',
  'avdra',
  'aveny',
  'avers',
  'avgud',
  'avhol',
  'avind',
  'avise',
  'aviso',
  'avkle',
  'avkok',
  'avkom',
  'avlat',
  'avlyd',
  'avrop',
  'avsig',
  'avsky',
  'avsug',
  'avsvi',
  'avtak',
  'avund',
  'avveg',
  'avvei',
  'avvik',
  'babel',
  'bable',
  'bacon',
  'baden',
  'bader',
  'bahai',
  'bahia',
  'bajas',
  'baker',
  'bakke',
  'bakli',
  'bakol',
  'bakom',
  'bakre',
  'bakse',
  'bakst',
  'bakut',
  'balje',
  'balle',
  'balsa',
  'bamse',
  'banak',
  'banal',
  'banan',
  'bande',
  'bandy',
  'bange',
  'banjo',
  'banke',
  'banko',
  'banne',
  'bantu',
  'barde',
  'bardu',
  'barka',
  'barke',
  'baron',
  'barre',
  'barsk',
  'basal',
  'basar',
  'basel',
  'basis',
  'baske',
  'basme',
  'basse',
  'basso',
  'basta',
  'baste',
  'basun',
  'batch',
  'baton',
  'bator',
  'bauge',
  'bause',
  'bauta',
  'baute',
  'bayer',
  'beach',
  'bedra',
  'bedre',
  'befal',
  'befri',
  'beger',
  'begge',
  'beglo',
  'begna',
  'behag',
  'behov',
  'beige',
  'beile',
  'beine',
  'being',
  'beira',
  'beise',
  'beisk',
  'beist',
  'beite',
  'beito',
  'bejae',
  'bekle',
  'belje',
  'belme',
  'belte',
  'bende',
  'benet',
  'benke',
  'bente',
  'beret',
  'berge',
  'bergh',
  'berit',
  'berme',
  'bernt',
  'berte',
  'besne',
  'besyv',
  'betel',
  'betle',
  'betre',
  'betro',
  'beven',
  'bever',
  'bevis',
  'bevre',
  'biavl',
  'bibel',
  'bidig',
  'bidra',
  'bielv',
  'bifag',
  'bifil',
  'bigam',
  'biing',
  'bikke',
  'bikse',
  'bikte',
  'bilag',
  'bilde',
  'bille',
  'bilyd',
  'bimbo',
  'binde',
  'binge',
  'bingo',
  'binne',
  'binom',
  'bisak',
  'bisam',
  'bisle',
  'bisne',
  'bisol',
  'bison',
  'biten',
  'bitte',
  'bivre',
  'bizet',
  'bjeff',
  'bjerk',
  'bjugn',
  'blaff',
  'blakk',
  'blanc',
  'blank',
  'blant',
  'blass',
  'blaut',
  'bleie',
  'bleig',
  'bleik',
  'bleke',
  'blekk',
  'blest',
  'blikk',
  'blind',
  'blink',
  'blits',
  'blitz',
  'blive',
  'block',
  'blogg',
  'blokk',
  'blome',
  'blond',
  'blote',
  'blott',
  'blues',
  'bluff',
  'blund',
  'blunk',
  'bluse',
  'bluss',
  'blygd',
  'bobby',
  'bobil',
  'boble',
  'bodil',
  'bodin',
  'bogen',
  'bogey',
  'boggi',
  'bogne',
  'bohem',
  'boing',
  'bojar',
  'bokne',
  'bokse',
  'boler',
  'bolig',
  'bolke',
  'bolle',
  'bolne',
  'bolte',
  'bombe',
  'bomme',
  'bonde',
  'bonge',
  'bongo',
  'bonum',
  'bonus',
  'booke',
  'boots',
  'bopel',
  'borat',
  'borde',
  'borer',
  'borge',
  'boris',
  'borka',
  'borre',
  'borsj',
  'borte',
  'borti',
  'bosse',
  'botid',
  'botne',
  'bowle',
  'bragd',
  'brake',
  'brakk',
  'brand',
  'brann',
  'brase',
  'brask',
  'brass',
  'brast',
  'bratt',
  'braut',
  'brava',
  'bravo',
  'bredd',
  'brede',
  'breie',
  'breim',
  'breis',
  'breke',
  'brekk',
  'brems',
  'brett',
  'brife',
  'brigg',
  'briks',
  'brink',
  'brise',
  'brisk',
  'brist',
  'brita',
  'brite',
  'britt',
  'brodd',
  'brokk',
  'brott',
  'brown',
  'brudd',
  'bruke',
  'brukt',
  'bruna',
  'brune',
  'brunt',
  'bruse',
  'brusk',
  'bruun',
  'brydd',
  'brygg',
  'bryne',
  'brysk',
  'bryst',
  'bryte',
  'bubil',
  'buden',
  'bufar',
  'buffe',
  'buffo',
  'bufre',
  'bugge',
  'bugne',
  'buing',
  'bukke',
  'bukle',
  'bukse',
  'bukte',
  'bulet',
  'bulke',
  'bulle',
  'bulne',
  'bumse',
  'bunad',
  'bunke',
  'bunne',
  'bunte',
  'buorm',
  'burde',
  'burka',
  'burma',
  'burot',
  'buske',
  'busse',
  'buste',
  'butan',
  'butid',
  'butte',
  'bybud',
  'bydag',
  'bydel',
  'byget',
  'bygge',
  'bying',
  'bykle',
  'bykse',
  'byliv',
  'bylte',
  'bymur',
  'byrde',
  'bysse',
  'byste',
  'bytte',
  'bytur',
  'cadiz',
  'campe',
  'capri',
  'cargo',
  'cashe',
  'celle',
  'cello',
  'cesur',
  'chief',
  'chile',
  'chili',
  'chips',
  'choke',
  'chuck',
  'cirka',
  'citer',
  'claus',
  'cobol',
  'cocom',
  'codex',
  'conga',
  'corny',
  'costa',
  'cover',
  'crack',
  'crawl',
  'crazy',
  'credo',
  'crepe',
  'cross',
  'culpa',
  'curie',
  'cykel',
  'cyste',
  'dabbe',
  'dacca',
  'dachs',
  'dadda',
  'dadle',
  'daffe',
  'dages',
  'dagne',
  'dahle',
  'dakar',
  'dalbu',
  'dalby',
  'daler',
  'dalet',
  'dalke',
  'dalle',
  'dalte',
  'dampe',
  'dandy',
  'danke',
  'danna',
  'danne',
  'danse',
  'dansk',
  'darre',
  'daske',
  'datel',
  'datid',
  'dativ',
  'dator',
  'datum',
  'daude',
  'david',
  'davit',
  'debet',
  'debil',
  'debut',
  'decca',
  'degge',
  'deild',
  'deise',
  'deist',
  'dekan',
  'dekar',
  'dekke',
  'dekor',
  'deler',
  'delfi',
  'delhi',
  'delje',
  'delta',
  'demme',
  'demon',
  'dempe',
  'demre',
  'denar',
  'denge',
  'denim',
  'denne',
  'depot',
  'deppa',
  'deppe',
  'derav',
  'derby',
  'deres',
  'derom',
  'derre',
  'desim',
  'desto',
  'dette',
  'devon',
  'devot',
  'diare',
  'didym',
  'diego',
  'diett',
  'digel',
  'diger',
  'digge',
  'diing',
  'dijon',
  'dikke',
  'dikte',
  'dildo',
  'dille',
  'dilte',
  'dimme',
  'dinar',
  'diner',
  'dingo',
  'dings',
  'diode',
  'dipol',
  'dirke',
  'dirre',
  'diset',
  'disig',
  'diske',
  'disko',
  'disse',
  'ditto',
  'divan',
  'djerv',
  'djupn',
  'dnepr',
  'dobbe',
  'doble',
  'dodge',
  'dodre',
  'dogge',
  'dogme',
  'dokka',
  'dokke',
  'dolce',
  'dolke',
  'domra',
  'donau',
  'donna',
  'donor',
  'doppe',
  'dorer',
  'dorge',
  'doris',
  'dorme',
  'dorsk',
  'doser',
  'dosis',
  'dotte',
  'doven',
  'dover',
  'dovne',
  'dovre',
  'doyen',
  'draft',
  'drage',
  'drake',
  'drakt',
  'drama',
  'drank',
  'drass',
  'draug',
  'dregg',
  'dreie',
  'dreis',
  'drene',
  'dreng',
  'drepe',
  'dress',
  'drett',
  'drift',
  'drikk',
  'driks',
  'drill',
  'drink',
  'drite',
  'driva',
  'drive',
  'droge',
  'drone',
  'dropp',
  'drops',
  'drott',
  'drunt',
  'dryge',
  'drypp',
  'dryss',
  'dubai',
  'dubbe',
  'duble',
  'duell',
  'duett',
  'dufte',
  'dugge',
  'dukat',
  'dukke',
  'dulgt',
  'dulle',
  'dulme',
  'dulte',
  'dumma',
  'dumme',
  'dummy',
  'dumpe',
  'dunet',
  'dunge',
  'dunke',
  'dunse',
  'dunst',
  'duplo',
  'duppe',
  'durra',
  'dusen',
  'dusin',
  'dusje',
  'duske',
  'duste',
  'dutte',
  'dvale',
  'dvask',
  'dveil',
  'dvele',
  'dverg',
  'dyade',
  'dybde',
  'dydig',
  'dying',
  'dykke',
  'dylle',
  'dynge',
  'dynke',
  'dyppe',
  'dyrke',
  'dysse',
  'dyste',
  'dytte',
  'eagle',
  'ebola',
  'edder',
  'eddik',
  'eders',
  'edikt',
  'efter',
  'efugl',
  'egdal',
  'egdsk',
  'eglet',
  'egner',
  'egnet',
  'egypt',
  'eidem',
  'eigen',
  'eiing',
  'eiker',
  'eilat',
  'einar',
  'einer',
  'eiret',
  'eirik',
  'eitel',
  'eiter',
  'eitre',
  'ekall',
  'ekkel',
  'ekorn',
  'eksem',
  'eksil',
  'eksis',
  'eksos',
  'eland',
  'elbil',
  'eldar',
  'eldes',
  'eldre',
  'elegi',
  'elgku',
  'elias',
  'eling',
  'elite',
  'elkem',
  'ellef',
  'ellen',
  'eller',
  'ellok',
  'eloge',
  'elske',
  'elvis',
  'emmen',
  'enare',
  'ender',
  'endiv',
  'endog',
  'endre',
  'engan',
  'engel',
  'enhet',
  'ening',
  'enkel',
  'enket',
  'enkom',
  'enorm',
  'enrom',
  'enske',
  'ensom',
  'enten',
  'entre',
  'envis',
  'enzym',
  'eocen',
  'epikk',
  'episk',
  'epoke',
  'epost',
  'erdal',
  'ergre',
  'erika',
  'erten',
  'ertet',
  'ertog',
  'ervik',
  'esing',
  'esker',
  'espen',
  'espoo',
  'espri',
  'essay',
  'essen',
  'ester',
  'estet',
  'etikk',
  'eting',
  'etisk',
  'etser',
  'etter',
  'ettid',
  'etyde',
  'fabel',
  'fable',
  'facts',
  'fader',
  'faens',
  'fager',
  'fagne',
  'faite',
  'fakir',
  'fakke',
  'fakle',
  'fakse',
  'fakta',
  'fakte',
  'falby',
  'falch',
  'falde',
  'falle',
  'falme',
  'false',
  'falsk',
  'falun',
  'famle',
  'fancy',
  'fange',
  'farad',
  'farao',
  'faren',
  'farga',
  'farge',
  'farin',
  'farke',
  'farse',
  'farsi',
  'farte',
  'farve',
  'fasan',
  'fasin',
  'fasit',
  'fasle',
  'faste',
  'fatal',
  'fatle',
  'fatta',
  'fatte',
  'fatum',
  'fatwa',
  'fauke',
  'fauna',
  'favne',
  'feavl',
  'feber',
  'fecit',
  'fedde',
  'fedje',
  'fedme',
  'fefot',
  'feide',
  'feier',
  'feile',
  'feire',
  'feite',
  'fekar',
  'fekte',
  'felge',
  'felle',
  'femte',
  'femti',
  'fenad',
  'fenge',
  'fenol',
  'ferde',
  'ferge',
  'ferie',
  'ferje',
  'ferme',
  'fersk',
  'ferte',
  'feste',
  'fetne',
  'fevik',
  'fiane',
  'fiber',
  'fidus',
  'fiffe',
  'fifle',
  'fight',
  'figur',
  'fiken',
  'fikle',
  'fikse',
  'fikte',
  'filer',
  'filet',
  'fille',
  'filme',
  'filur',
  'final',
  'finer',
  'finis',
  'finke',
  'finne',
  'finse',
  'finsk',
  'finte',
  'firer',
  'firma',
  'firti',
  'fisen',
  'fiske',
  'fisle',
  'fiste',
  'fitte',
  'fjase',
  'fjeld',
  'fjelg',
  'fjell',
  'fjern',
  'fjert',
  'fjesk',
  'fjoll',
  'fjols',
  'fjomp',
  'fjong',
  'fjord',
  'fjott',
  'flabb',
  'flage',
  'flagg',
  'flake',
  'flakk',
  'flaks',
  'flane',
  'flaps',
  'flare',
  'flash',
  'flask',
  'flass',
  'flate',
  'flaue',
  'fleip',
  'fleis',
  'flekk',
  'fleng',
  'flens',
  'flere',
  'flesk',
  'flidd',
  'flike',
  'flikk',
  'flink',
  'flint',
  'flipp',
  'flire',
  'flise',
  'floke',
  'flokk',
  'floks',
  'flopp',
  'flora',
  'floss',
  'flott',
  'fluid',
  'fluks',
  'flukt',
  'fluor',
  'flush',
  'flusk',
  'fluss',
  'flust',
  'flyer',
  'flyge',
  'flyte',
  'flyve',
  'fnatt',
  'fnise',
  'fnokk',
  'fnugg',
  'fnyse',
  'foaje',
  'fokal',
  'fokus',
  'folde',
  'folie',
  'folio',
  'folke',
  'folle',
  'follo',
  'folne',
  'fomle',
  'fonds',
  'fondy',
  'fonem',
  'fonne',
  'foods',
  'foran',
  'forbi',
  'forby',
  'force',
  'fordi',
  'forgi',
  'forme',
  'forre',
  'forse',
  'forst',
  'forta',
  'forte',
  'forum',
  'forus',
  'forut',
  'fosli',
  'fosna',
  'fosse',
  'foton',
  'foyer',
  'frabe',
  'frakk',
  'frakt',
  'framt',
  'franc',
  'frank',
  'frans',
  'franz',
  'frase',
  'frasi',
  'frata',
  'freak',
  'frede',
  'frege',
  'freia',
  'frekk',
  'frels',
  'fremt',
  'freon',
  'frese',
  'fresj',
  'freud',
  'frier',
  'frigg',
  'frigi',
  'frise',
  'frisk',
  'frist',
  'frita',
  'frode',
  'frogn',
  'front',
  'frosk',
  'frost',
  'frukt',
  'fryde',
  'frykt',
  'fryse',
  'fukte',
  'funke',
  'furer',
  'furet',
  'furie',
  'furte',
  'fusel',
  'fuske',
  'fusse',
  'futil',
  'futte',
  'fying',
  'fylde',
  'fylke',
  'fylle',
  'fymat',
  'fyord',
  'fyrig',
  'fyrop',
  'fyrst',
  'fysak',
  'fysen',
  'gabon',
  'gafle',
  'gagne',
  'gagns',
  'gaide',
  'gakke',
  'galan',
  'galei',
  'galen',
  'galge',
  'galla',
  'galle',
  'galon',
  'galte',
  'gaman',
  'gambe',
  'gamet',
  'gamin',
  'gamla',
  'gamma',
  'gamme',
  'gampe',
  'gande',
  'ganer',
  'gange',
  'gante',
  'gapen',
  'gaper',
  'gapet',
  'gaple',
  'garde',
  'garmo',
  'garne',
  'garni',
  'garpe',
  'garva',
  'garve',
  'gasje',
  'gasse',
  'gasta',
  'gauda',
  'gauge',
  'gauke',
  'gaula',
  'gaule',
  'gaume',
  'gaupe',
  'gauss',
  'gebet',
  'gebyr',
  'geilo',
  'geine',
  'geipe',
  'geire',
  'geist',
  'geite',
  'gekko',
  'gemal',
  'gemen',
  'gemme',
  'gemse',
  'genre',
  'genus',
  'georg',
  'gerda',
  'getto',
  'gevir',
  'ghana',
  'gidde',
  'gifte',
  'gigge',
  'gilde',
  'gilje',
  'gimpe',
  'gimse',
  'ginst',
  'gipse',
  'giske',
  'gisle',
  'gisne',
  'gispe',
  'gisse',
  'gitar',
  'gitre',
  'giver',
  'gjall',
  'gjekk',
  'gjeld',
  'gjeng',
  'gjepe',
  'gjerd',
  'gjert',
  'gjesp',
  'gjest',
  'gjete',
  'gjord',
  'gjure',
  'glace',
  'glafs',
  'glane',
  'glans',
  'glapp',
  'glass',
  'glatt',
  'glede',
  'glefs',
  'glenn',
  'glepp',
  'glett',
  'glide',
  'glima',
  'glime',
  'glimt',
  'glipe',
  'glipp',
  'glire',
  'glise',
  'glore',
  'glose',
  'glove',
  'glugg',
  'gnage',
  'gnask',
  'gneis',
  'gnell',
  'gnier',
  'gnirk',
  'gniss',
  'gnist',
  'gnome',
  'gnure',
  'godta',
  'godte',
  'gojim',
  'gomle',
  'gomme',
  'gople',
  'goter',
  'gouda',
  'grabb',
  'grace',
  'grade',
  'grand',
  'grane',
  'grann',
  'graps',
  'grase',
  'grate',
  'graut',
  'grave',
  'great',
  'green',
  'greie',
  'grein',
  'greip',
  'grell',
  'grend',
  'grene',
  'grepa',
  'grepp',
  'gresk',
  'gress',
  'greta',
  'grete',
  'greve',
  'gribb',
  'grieg',
  'griff',
  'grill',
  'grime',
  'grind',
  'grine',
  'grini',
  'gripe',
  'grise',
  'grisk',
  'grjot',
  'grogg',
  'grong',
  'grope',
  'gross',
  'grube',
  'gruff',
  'grugg',
  'grukk',
  'grums',
  'grunk',
  'grunn',
  'gruse',
  'grusk',
  'gruve',
  'gryne',
  'grynt',
  'gryte',
  'guano',
  'gubbe',
  'guffe',
  'gufse',
  'gugge',
  'guide',
  'gulen',
  'gulke',
  'gulne',
  'gulpe',
  'gumle',
  'gumme',
  'gummi',
  'gunst',
  'gurid',
  'gurpe',
  'guste',
  'gvarv',
  'gydje',
  'gyger',
  'gylle',
  'gylne',
  'gylte',
  'gymme',
  'gynge',
  'gyser',
  'gysje',
  'gytje',
  'gyvel',
  'habil',
  'hacke',
  'hagel',
  'hagen',
  'hagle',
  'haifa',
  'haike',
  'haiku',
  'haing',
  'haiti',
  'hakke',
  'halal',
  'halle',
  'hallo',
  'halma',
  'halon',
  'halsa',
  'halse',
  'halte',
  'halve',
  'halvt',
  'hamar',
  'hambo',
  'hamle',
  'hamne',
  'hamre',
  'hamse',
  'hands',
  'hanke',
  'hanna',
  'hanne',
  'hanoi',
  'hansa',
  'hanse',
  'happy',
  'haram',
  'harem',
  'harke',
  'harme',
  'harpe',
  'harpy',
  'harry',
  'harsk',
  'harve',
  'hasje',
  'haspe',
  'haste',
  'hater',
  'hatig',
  'hatsk',
  'hauge',
  'hauke',
  'hauld',
  'hausa',
  'havis',
  'havne',
  'havre',
  'heade',
  'hedda',
  'hedde',
  'heden',
  'heder',
  'hedre',
  'hefte',
  'hegde',
  'hegel',
  'hegem',
  'hegge',
  'hegna',
  'hegne',
  'hegra',
  'hegre',
  'heidi',
  'heien',
  'heile',
  'heilo',
  'heime',
  'heine',
  'heire',
  'heise',
  'heiti',
  'hekke',
  'hekla',
  'hekle',
  'hekse',
  'hekte',
  'hekto',
  'helde',
  'heler',
  'helga',
  'helge',
  'helle',
  'helly',
  'helot',
  'helse',
  'helst',
  'helvt',
  'hemme',
  'hemne',
  'hempe',
  'hemse',
  'henad',
  'hende',
  'hendt',
  'henge',
  'hengi',
  'henna',
  'henne',
  'henry',
  'hente',
  'heppe',
  'herav',
  'herde',
  'herje',
  'herke',
  'herme',
  'herom',
  'heros',
  'herpe',
  'herre',
  'herse',
  'hertz',
  'hesje',
  'hespe',
  'hetne',
  'hetse',
  'hette',
  'hevde',
  'hevle',
  'hevne',
  'higen',
  'hijab',
  'hikke',
  'hikst',
  'hilde',
  'hilse',
  'himle',
  'hindi',
  'hindu',
  'hinke',
  'hinna',
  'hinne',
  'hinte',
  'hiren',
  'hirse',
  'hisse',
  'hitra',
  'hitre',
  'hitte',
  'hiver',
  'hjalt',
  'hjell',
  'hjelm',
  'hjelp',
  'hjord',
  'hjort',
  'hjule',
  'hjupe',
  'hobby',
  'hocke',
  'hodde',
  'hodne',
  'hofte',
  'hogge',
  'hogst',
  'holde',
  'holdt',
  'holet',
  'holke',
  'holme',
  'holne',
  'holst',
  'holte',
  'holth',
  'holum',
  'homme',
  'homse',
  'honda',
  'hoppe',
  'horde',
  'horse',
  'horst',
  'hoste',
  'house',
  'hovda',
  'hovde',
  'hovel',
  'hoven',
  'hovin',
  'hovle',
  'hovne',
  'hovre',
  'hubro',
  'hufse',
  'hugal',
  'hugav',
  'hugge',
  'hugst',
  'hugta',
  'huhei',
  'hukre',
  'hulag',
  'hulke',
  'hulle',
  'human',
  'humid',
  'humle',
  'humor',
  'humpe',
  'humre',
  'humul',
  'humus',
  'huner',
  'huron',
  'hurpe',
  'hurra',
  'hurre',
  'hurum',
  'husar',
  'huske',
  'husky',
  'husly',
  'hutle',
  'hutre',
  'hvalp',
  'hvass',
  'hvelv',
  'hveps',
  'hvese',
  'hvete',
  'hvile',
  'hvine',
  'hvisk',
  'hvite',
  'hvitt',
  'hvori',
  'hybel',
  'hydra',
  'hydro',
  'hyene',
  'hyete',
  'hygea',
  'hygge',
  'hykle',
  'hyler',
  'hylle',
  'hylse',
  'hymen',
  'hymne',
  'hynde',
  'hynne',
  'hyppe',
  'hyrde',
  'hysje',
  'hysse',
  'hytte',
  'haave',
  'ibiza',
  'ibsen',
  'icing',
  'idaho',
  'ideal',
  'ident',
  'idest',
  'idiom',
  'idiot',
  'idyll',
  'ifall',
  'ifjor',
  'igang',
  'igjen',
  'iguan',
  'ihjel',
  'ihuga',
  'iktus',
  'iland',
  'ilbud',
  'ilder',
  'ildne',
  'ilegg',
  'iling',
  'ilske',
  'ilsom',
  'ilter',
  'iltog',
  'image',
  'imago',
  'imens',
  'immun',
  'inari',
  'inatt',
  'inder',
  'india',
  'indre',
  'inert',
  'infam',
  'infus',
  'ingar',
  'ingen',
  'inger',
  'ingri',
  'ingun',
  'innad',
  'innbe',
  'innbo',
  'innbu',
  'innby',
  'innen',
  'inngi',
  'innom',
  'innse',
  'innta',
  'input',
  'intet',
  'intim',
  'inuit',
  'irene',
  'iring',
  'irisk',
  'ironi',
  'irret',
  'isand',
  'isbar',
  'isbit',
  'isbor',
  'isbre',
  'isete',
  'isfot',
  'isfri',
  'ishav',
  'ishud',
  'ishus',
  'ising',
  'islag',
  'islam',
  'islom',
  'ispil',
  'isres',
  'ister',
  'istid',
  'ivalo',
  'ivevd',
  'ivrig',
  'izmir',
  'jabbe',
  'jacob',
  'jaffa',
  'jafse',
  'jager',
  'jaggu',
  'jahre',
  'jahve',
  'jakke',
  'jakku',
  'jakob',
  'jakte',
  'jalme',
  'jalta',
  'jambe',
  'jamen',
  'jamme',
  'jamne',
  'jamre',
  'jamte',
  'janus',
  'jaord',
  'japan',
  'jaren',
  'jarle',
  'jaske',
  'jasse',
  'jatte',
  'javel',
  'jazze',
  'jeans',
  'jeger',
  'jekke',
  'jelke',
  'jelsa',
  'jemte',
  'jenka',
  'jenke',
  'jenny',
  'jente',
  'jerpe',
  'jesus',
  'jette',
  'jevne',
  'jibbe',
  'jidda',
  'jingo',
  'jippo',
  'jobbe',
  'jodid',
  'jodle',
  'jogge',
  'joggu',
  'johan',
  'joike',
  'joker',
  'jolle',
  'jonas',
  'joner',
  'jorde',
  'jorte',
  'jorun',
  'josef',
  'jotun',
  'joule',
  'jubel',
  'juble',
  'judas',
  'jugle',
  'juice',
  'jukse',
  'julia',
  'julle',
  'jumbo',
  'jumpe',
  'junge',
  'junke',
  'junta',
  'juris',
  'jutul',
  'juvel',
  'kabal',
  'kabbe',
  'kabel',
  'kabin',
  'kable',
  'kabul',
  'kabyl',
  'kader',
  'kaffe',
  'kafir',
  'kafka',
  'kagge',
  'kairo',
  'kajal',
  'kakao',
  'kakke',
  'kakle',
  'kakse',
  'kalas',
  'kalif',
  'kalke',
  'kalle',
  'kalun',
  'kalve',
  'kambo',
  'kamel',
  'kamin',
  'kamme',
  'kamse',
  'kanak',
  'kanal',
  'kanel',
  'kanin',
  'kanne',
  'kanon',
  'kante',
  'kaper',
  'kapok',
  'kappe',
  'kapre',
  'kapun',
  'karat',
  'karde',
  'karen',
  'karet',
  'kargo',
  'karib',
  'karin',
  'karma',
  'karpe',
  'karre',
  'karri',
  'karse',
  'karsk',
  'karte',
  'karve',
  'kasko',
  'kassa',
  'kasse',
  'kaste',
  'kasus',
  'kater',
  'katet',
  'katte',
  'kauke',
  'kause',
  'kavai',
  'kavet',
  'kavle',
  'kebab',
  'kediv',
  'kefir',
  'keike',
  'keite',
  'keive',
  'kelat',
  'kelim',
  'kendo',
  'kenya',
  'keram',
  'keton',
  'khaki',
  'khmer',
  'kibbe',
  'kijev',
  'kiker',
  'kikke',
  'kikne',
  'kikre',
  'kikse',
  'kikut',
  'kilde',
  'kilen',
  'kiler',
  'kille',
  'kimse',
  'kinge',
  'kinin',
  'kinke',
  'kinks',
  'kinne',
  'kiosk',
  'kipen',
  'kiper',
  'kippe',
  'kirke',
  'kirov',
  'kisel',
  'kisle',
  'kiste',
  'kitin',
  'kitle',
  'kitte',
  'kives',
  'kjake',
  'kjaks',
  'kjapp',
  'kjase',
  'kjave',
  'kjede',
  'kjeft',
  'kjekk',
  'kjeks',
  'kjeld',
  'kjele',
  'kjell',
  'kjemi',
  'kjeng',
  'kjent',
  'kjepp',
  'kjerr',
  'kjerv',
  'kjese',
  'kjesk',
  'kjeve',
  'kjoks',
  'kjole',
  'kjone',
  'kjuke',
  'klabb',
  'kladd',
  'klaff',
  'klage',
  'klake',
  'klakk',
  'klamp',
  'klang',
  'klant',
  'klapp',
  'klaps',
  'klare',
  'klase',
  'klask',
  'klatt',
  'klaus',
  'klauv',
  'klave',
  'klebe',
  'klede',
  'klegg',
  'kleie',
  'kleim',
  'klein',
  'kleis',
  'kleiv',
  'klekk',
  'klemt',
  'klepp',
  'klerk',
  'kless',
  'klett',
  'kleve',
  'klien',
  'klikk',
  'klima',
  'kline',
  'kling',
  'klink',
  'klipe',
  'klipp',
  'klips',
  'klirr',
  'kliss',
  'klive',
  'klode',
  'klone',
  'klopp',
  'klore',
  'kloss',
  'klove',
  'klovn',
  'klubb',
  'kluft',
  'klukk',
  'klump',
  'klums',
  'klunk',
  'kluns',
  'kluss',
  'klynk',
  'klype',
  'klyse',
  'klyss',
  'klyve',
  'knabb',
  'knagg',
  'knake',
  'knakk',
  'knall',
  'knapp',
  'knapt',
  'knark',
  'knarr',
  'knart',
  'knase',
  'knask',
  'knast',
  'knatt',
  'knaus',
  'knege',
  'knegg',
  'kneik',
  'knekk',
  'knekt',
  'knele',
  'knepp',
  'knert',
  'knest',
  'knett',
  'kniks',
  'knipe',
  'knips',
  'knirk',
  'knise',
  'knisl',
  'knive',
  'knode',
  'knoge',
  'knoke',
  'knoll',
  'knope',
  'knopp',
  'knort',
  'knote',
  'knott',
  'knubb',
  'knuge',
  'knull',
  'knult',
  'knupp',
  'knups',
  'knurr',
  'knurv',
  'knuse',
  'knusk',
  'knute',
  'knutt',
  'knuvl',
  'knyst',
  'knyte',
  'koaks',
  'koala',
  'kobbe',
  'koble',
  'kobra',
  'kodak',
  'kodde',
  'koder',
  'kofte',
  'kogge',
  'kogle',
  'koker',
  'kokke',
  'kokos',
  'kokre',
  'kokse',
  'kolbe',
  'kolbu',
  'kolet',
  'kolin',
  'kolje',
  'kolle',
  'kolli',
  'kolon',
  'kolos',
  'komet',
  'komle',
  'komma',
  'komme',
  'kompe',
  'komse',
  'konge',
  'kongo',
  'konke',
  'konte',
  'konto',
  'konus',
  'kopal',
  'kopek',
  'kopen',
  'kople',
  'koppe',
  'kopra',
  'koral',
  'koran',
  'korde',
  'korea',
  'korfu',
  'korka',
  'korke',
  'korne',
  'korny',
  'korps',
  'korse',
  'korte',
  'koste',
  'kovne',
  'krafs',
  'kraft',
  'krage',
  'kragg',
  'krake',
  'krakk',
  'krane',
  'krank',
  'krans',
  'krapp',
  'krase',
  'krasj',
  'krasl',
  'krass',
  'kratt',
  'krave',
  'kravl',
  'kreft',
  'kreke',
  'kreml',
  'kremt',
  'kreol',
  'krepp',
  'kreps',
  'kreta',
  'kreti',
  'krets',
  'kreve',
  'krige',
  'krill',
  'krime',
  'kring',
  'krink',
  'krins',
  'krise',
  'krist',
  'krite',
  'kritt',
  'kroat',
  'krogh',
  'krohn',
  'kroke',
  'kroki',
  'krone',
  'kroon',
  'kropp',
  'krote',
  'krugg',
  'kruke',
  'krull',
  'krupp',
  'kruse',
  'krutt',
  'krymp',
  'kryne',
  'krype',
  'krypt',
  'kryss',
  'kraal',
  'kuala',
  'kubbe',
  'kuben',
  'kubus',
  'kudos',
  'kufor',
  'kufte',
  'kuing',
  'kujon',
  'kulde',
  'kulle',
  'kulse',
  'kulte',
  'kumla',
  'kumle',
  'kumme',
  'kumpe',
  'kunde',
  'kunke',
  'kunne',
  'kunst',
  'kuple',
  'kuppe',
  'kurer',
  'kurie',
  'kurle',
  'kurre',
  'kurse',
  'kurve',
  'kuske',
  'kusma',
  'kuste',
  'kutte',
  'kuven',
  'kuvet',
  'kvabb',
  'kvakk',
  'kvale',
  'kvalm',
  'kvann',
  'kvant',
  'kvaps',
  'kvare',
  'kvarg',
  'kvark',
  'kvart',
  'kvarv',
  'kvase',
  'kvass',
  'kvast',
  'kvede',
  'kvege',
  'kveik',
  'kveil',
  'kvein',
  'kveis',
  'kveke',
  'kvekk',
  'kveld',
  'kvele',
  'kvell',
  'kvelv',
  'kvepp',
  'kverk',
  'kvern',
  'kverv',
  'kvese',
  'kvess',
  'kveve',
  'kvide',
  'kvige',
  'kvike',
  'kvikk',
  'kvile',
  'kvine',
  'kvink',
  'kvint',
  'kvise',
  'kviss',
  'kvist',
  'kvite',
  'kvitt',
  'kvote',
  'kylle',
  'kylne',
  'kynde',
  'kynne',
  'kyoto',
  'kyrie',
  'kysse',
  'kaare',
  'kaasa',
  'laban',
  'labbe',
  'laber',
  'labil',
  'ladde',
  'laden',
  'lader',
  'lafte',
  'lager',
  'lagge',
  'lagje',
  'lagom',
  'lagos',
  'lagre',
  'lahti',
  'laila',
  'laing',
  'lakei',
  'laken',
  'lakke',
  'lalle',
  'lamme',
  'lampe',
  'lande',
  'lange',
  'langs',
  'langt',
  'lanka',
  'lanke',
  'lanse',
  'lapis',
  'lappe',
  'largo',
  'larme',
  'larve',
  'laser',
  'laset',
  'laske',
  'lasse',
  'lasso',
  'laste',
  'lasur',
  'laten',
  'latin',
  'lauge',
  'laure',
  'lauve',
  'lavik',
  'lavvo',
  'lease',
  'ledde',
  'leder',
  'ledes',
  'ledig',
  'leeds',
  'lefle',
  'lefse',
  'legal',
  'legat',
  'legde',
  'legge',
  'legio',
  'leide',
  'leier',
  'leies',
  'leigh',
  'leike',
  'leing',
  'leira',
  'leire',
  'leite',
  'leivd',
  'leive',
  'leken',
  'leker',
  'lekke',
  'lekre',
  'lekse',
  'lekte',
  'lemen',
  'lemma',
  'lemme',
  'lempe',
  'lemur',
  'lemus',
  'lende',
  'lenge',
  'lengt',
  'lenin',
  'lenke',
  'lense',
  'leone',
  'lepje',
  'leppe',
  'lepra',
  'lerke',
  'lesbe',
  'leser',
  'lesja',
  'leske',
  'lespe',
  'lesse',
  'leste',
  'lesto',
  'leter',
  'letne',
  'lette',
  'leven',
  'lever',
  'levne',
  'levre',
  'lhasa',
  'libya',
  'ligge',
  'light',
  'ligne',
  'liing',
  'likne',
  'lilje',
  'lilla',
  'lille',
  'limbo',
  'limer',
  'linda',
  'linde',
  'lingo',
  'linje',
  'linke',
  'links',
  'linne',
  'linon',
  'linse',
  'lipid',
  'lipom',
  'lirke',
  'lisse',
  'liste',
  'litas',
  'liten',
  'liter',
  'litot',
  'livat',
  'liver',
  'livne',
  'livre',
  'ljome',
  'ljore',
  'ljuge',
  'lobbe',
  'lobby',
  'lodde',
  'loden',
  'lodje',
  'loete',
  'loffe',
  'logge',
  'logre',
  'lohne',
  'loing',
  'loire',
  'lojal',
  'lokal',
  'lokke',
  'lomme',
  'lompe',
  'lomre',
  'lomvi',
  'longe',
  'longs',
  'loope',
  'loppa',
  'loppe',
  'loran',
  'lorje',
  'losje',
  'losji',
  'losse',
  'lothe',
  'lotte',
  'lotto',
  'lotus',
  'louis',
  'lubbe',
  'lucia',
  'luffe',
  'lufte',
  'lugar',
  'lugge',
  'lugne',
  'lugom',
  'lugum',
  'luing',
  'lukas',
  'lukke',
  'lukte',
  'lulle',
  'lumen',
  'lumpe',
  'lumsk',
  'lunch',
  'lunde',
  'lunet',
  'lunge',
  'lunke',
  'lunne',
  'lunsj',
  'lunte',
  'lupin',
  'lupus',
  'lurer',
  'lurke',
  'lurve',
  'lusen',
  'luset',
  'luske',
  'luten',
  'lutre',
  'luxor',
  'lybsk',
  'lydig',
  'lying',
  'lykke',
  'lykte',
  'lymfe',
  'lynde',
  'lynne',
  'lynol',
  'lyske',
  'lysne',
  'lysol',
  'lyste',
  'lytte',
  'macao',
  'macho',
  'madam',
  'madla',
  'mafia',
  'magda',
  'mager',
  'magge',
  'magma',
  'magne',
  'magni',
  'magre',
  'mahdi',
  'maile',
  'maine',
  'mainz',
  'major',
  'maken',
  'makke',
  'makko',
  'makro',
  'maksi',
  'makte',
  'malay',
  'maler',
  'malje',
  'malle',
  'malme',
  'malta',
  'malte',
  'mamba',
  'mambo',
  'mamma',
  'maner',
  'manet',
  'mange',
  'mango',
  'manke',
  'manko',
  'manna',
  'manne',
  'mansk',
  'manus',
  'maori',
  'mappe',
  'maren',
  'maria',
  'marie',
  'marin',
  'marit',
  'marki',
  'marme',
  'marsj',
  'marsk',
  'marta',
  'masai',
  'masen',
  'maser',
  'maset',
  'maske',
  'masse',
  'maste',
  'matbu',
  'match',
  'mater',
  'matos',
  'matre',
  'matro',
  'matte',
  'maule',
  'maure',
  'mayen',
  'mazda',
  'meded',
  'medgi',
  'medio',
  'medoc',
  'meget',
  'megge',
  'megle',
  'meine',
  'meise',
  'meite',
  'mekka',
  'mekke',
  'mekle',
  'mekre',
  'melbu',
  'melby',
  'melde',
  'melen',
  'melet',
  'melis',
  'melke',
  'melle',
  'melon',
  'melte',
  'mened',
  'menge',
  'menig',
  'mente',
  'merke',
  'merle',
  'mesan',
  'mesen',
  'meske',
  'meson',
  'messe',
  'metan',
  'meter',
  'metro',
  'mette',
  'metyl',
  'meyer',
  'mezzo',
  'miami',
  'midje',
  'midle',
  'midte',
  'mikal',
  'mikse',
  'mille',
  'mimre',
  'minde',
  'minke',
  'minne',
  'minst',
  'minus',
  'misse',
  'mista',
  'miste',
  'mitra',
  'mjaue',
  'mjele',
  'mjuke',
  'moare',
  'mobbe',
  'mobil',
  'modal',
  'modem',
  'moden',
  'moder',
  'modig',
  'modne',
  'modul',
  'modum',
  'modus',
  'moelv',
  'mogop',
  'mogul',
  'mokka',
  'molbo',
  'molde',
  'molok',
  'molte',
  'molto',
  'mompe',
  'monne',
  'monom',
  'moped',
  'moppe',
  'moral',
  'morin',
  'morna',
  'morra',
  'morse',
  'morsk',
  'mosel',
  'moset',
  'moske',
  'motiv',
  'motor',
  'motsi',
  'motta',
  'motto',
  'mount',
  'mudre',
  'muffe',
  'mufti',
  'mugge',
  'mugne',
  'mukke',
  'mulde',
  'mulen',
  'mulig',
  'mulkt',
  'mulla',
  'mulle',
  'mulne',
  'mulre',
  'multe',
  'mumie',
  'mumle',
  'mumse',
  'munch',
  'mungo',
  'munke',
  'munne',
  'murer',
  'murre',
  'musak',
  'muset',
  'musse',
  'muzak',
  'mycel',
  'mygle',
  'myhre',
  'mykis',
  'mykne',
  'mynde',
  'mynte',
  'myopi',
  'myose',
  'myran',
  'myrde',
  'myret',
  'myrra',
  'mysen',
  'myske',
  'mysli',
  'nabbe',
  'nabob',
  'nadir',
  'nafta',
  'nagle',
  'naken',
  'nakke',
  'nappa',
  'nappe',
  'narko',
  'narre',
  'narve',
  'nasal',
  'nasje',
  'naske',
  'natal',
  'natte',
  'natur',
  'naube',
  'naust',
  'navar',
  'navle',
  'navne',
  'nebbe',
  'nedad',
  'nedom',
  'nedre',
  'nedst',
  'neger',
  'negle',
  'neida',
  'neigu',
  'nekte',
  'nemko',
  'nemme',
  'nemnd',
  'nenne',
  'nepal',
  'nepen',
  'neppe',
  'nerts',
  'nerve',
  'nesle',
  'nesna',
  'nesse',
  'neste',
  'nette',
  'netto',
  'never',
  'nevne',
  'nibbe',
  'nidel',
  'nidsk',
  'niels',
  'niese',
  'niger',
  'nikab',
  'nikke',
  'nikse',
  'nilen',
  'nippe',
  'niqab',
  'nisje',
  'nisse',
  'niste',
  'niten',
  'nitid',
  'nitte',
  'nitti',
  'nobel',
  'nodul',
  'nogen',
  'nokia',
  'nokke',
  'nomen',
  'nonne',
  'norad',
  'nordi',
  'norge',
  'norne',
  'norol',
  'norsk',
  'north',
  'norum',
  'notar',
  'notat',
  'notis',
  'nubbe',
  'nudde',
  'nudel',
  'nufse',
  'nugat',
  'nugge',
  'nulle',
  'nulte',
  'nuppe',
  'nupre',
  'nuske',
  'nusle',
  'nusse',
  'nuvet',
  'nygle',
  'nyhet',
  'nying',
  'nykke',
  'nylig',
  'nylon',
  'nymfe',
  'nynne',
  'nyord',
  'nyrik',
  'nyter',
  'nytid',
  'nytte',
  'nyveg',
  'nyvei',
  'nyvle',
  'oasis',
  'oblat',
  'oblik',
  'odvar',
  'offer',
  'ofrer',
  'ohmsk',
  'oiing',
  'okapi',
  'oksid',
  'oksyd',
  'oktan',
  'oktav',
  'olaug',
  'olaus',
  'olden',
  'older',
  'oldis',
  'oljet',
  'olsen',
  'olsok',
  'olson',
  'omaha',
  'ombot',
  'ombud',
  'omdal',
  'omega',
  'omegn',
  'omfar',
  'omhug',
  'omlag',
  'omlyd',
  'omsut',
  'omsyn',
  'omveg',
  'omvei',
  'onani',
  'onkel',
  'onkos',
  'onyks',
  'opart',
  'opdal',
  'opera',
  'opiat',
  'opium',
  'oppad',
  'oppal',
  'oppby',
  'oppgi',
  'oppom',
  'oppsi',
  'oppta',
  'orden',
  'ordne',
  'ordre',
  'organ',
  'orgel',
  'orgie',
  'origo',
  'orkan',
  'orkla',
  'orlog',
  'orlon',
  'orlov',
  'ornat',
  'osaka',
  'oscar',
  'osean',
  'osing',
  'oskar',
  'osman',
  'osset',
  'otium',
  'ottes',
  'ounce',
  'overs',
  'pacer',
  'padde',
  'padle',
  'padre',
  'paffe',
  'pagai',
  'pagan',
  'pakke',
  'pakte',
  'palla',
  'palma',
  'palme',
  'pampe',
  'panda',
  'panel',
  'panne',
  'pante',
  'panty',
  'papir',
  'pappa',
  'pappe',
  'papua',
  'parat',
  'paria',
  'paris',
  'parre',
  'parti',
  'party',
  'pasja',
  'pasje',
  'passe',
  'pasta',
  'pater',
  'patos',
  'patte',
  'pauke',
  'pauli',
  'paulo',
  'pause',
  'pavet',
  'pedal',
  'peder',
  'pedro',
  'peile',
  'peise',
  'peker',
  'pelle',
  'pelme',
  'pelse',
  'penge',
  'penis',
  'penne',
  'penni',
  'penny',
  'pense',
  'pepre',
  'perle',
  'perse',
  'perth',
  'pesto',
  'peter',
  'petit',
  'petum',
  'phnom',
  'piano',
  'piece',
  'piffe',
  'pigge',
  'pilar',
  'pilke',
  'pille',
  'pilot',
  'pilte',
  'pimpe',
  'pinje',
  'pinke',
  'pinne',
  'pinse',
  'pinup',
  'piper',
  'pipet',
  'piple',
  'pippe',
  'pippi',
  'pirat',
  'piren',
  'pirke',
  'pirog',
  'pirol',
  'pirre',
  'pirse',
  'pirum',
  'piske',
  'pisse',
  'piste',
  'pitle',
  'pivot',
  'pixel',
  'pizza',
  'pjalt',
  'pjank',
  'pjatt',
  'pjokk',
  'pjusk',
  'plaff',
  'plage',
  'plagg',
  'plakk',
  'plane',
  'plank',
  'plask',
  'plass',
  'plast',
  'plata',
  'plate',
  'platt',
  'plebs',
  'pledd',
  'pleie',
  'plent',
  'pleti',
  'plett',
  'plikt',
  'pling',
  'plint',
  'plire',
  'plitt',
  'ploge',
  'plopp',
  'plott',
  'plugg',
  'plukk',
  'plump',
  'pluss',
  'plysj',
  'poeng',
  'poesi',
  'pokal',
  'poker',
  'pokka',
  'pokre',
  'polar',
  'polen',
  'polio',
  'polis',
  'polka',
  'polsk',
  'pomor',
  'ponni',
  'poppe',
  'poret',
  'porno',
  'porto',
  'posen',
  'poset',
  'poste',
  'potet',
  'potte',
  'praha',
  'praie',
  'prakk',
  'prakt',
  'prale',
  'prate',
  'prege',
  'preik',
  'preke',
  'prent',
  'press',
  'prest',
  'priar',
  'prikk',
  'prima',
  'prime',
  'primo',
  'prins',
  'prior',
  'prise',
  'proff',
  'promp',
  'propp',
  'props',
  'prosa',
  'prost',
  'prove',
  'provo',
  'prunk',
  'prupp',
  'prust',
  'prute',
  'pryde',
  'pryle',
  'psyke',
  'ptroe',
  'pubes',
  'pudle',
  'pudre',
  'puffe',
  'puger',
  'pugge',
  'pukka',
  'pukke',
  'pulje',
  'pulpa',
  'pulse',
  'pumpe',
  'pumps',
  'punch',
  'puner',
  'punge',
  'punkt',
  'punsj',
  'puppe',
  'purda',
  'purin',
  'purke',
  'purle',
  'purre',
  'puset',
  'pushe',
  'pusle',
  'pussa',
  'pusse',
  'puste',
  'putle',
  'putre',
  'putte',
  'putto',
  'pygme',
  'pynte',
  'pyore',
  'pysen',
  'pyset',
  'pyton',
  'qatar',
  'quart',
  'quipu',
  'quito',
  'rabbe',
  'rabbi',
  'rabid',
  'rable',
  'racer',
  'radar',
  'radde',
  'radig',
  'radio',
  'radom',
  'radon',
  'rafse',
  'rafte',
  'ragge',
  'ragna',
  'raide',
  'rakke',
  'rakle',
  'rakne',
  'rakst',
  'ralle',
  'rally',
  'ramle',
  'ramme',
  'rampe',
  'ramse',
  'ranch',
  'rande',
  'randi',
  'raner',
  'range',
  'ranke',
  'raper',
  'rapid',
  'rappe',
  'rapse',
  'raske',
  'rasle',
  'raspe',
  'raste',
  'ratio',
  'ratle',
  'raton',
  'ratsj',
  'ratte',
  'rauda',
  'rauke',
  'rauma',
  'rause',
  'raute',
  'rayon',
  'rebus',
  'redde',
  'reder',
  'redig',
  'reell',
  'refse',
  'regal',
  'regel',
  'regle',
  'regne',
  'reide',
  'reier',
  'reike',
  'reile',
  'reing',
  'reint',
  'reipe',
  'reise',
  'reive',
  'rekel',
  'reker',
  'rekke',
  'rekst',
  'rekyl',
  'remis',
  'remje',
  'remse',
  'renke',
  'renne',
  'rense',
  'rensk',
  'rente',
  'repos',
  'repro',
  'reser',
  'resin',
  'retor',
  'rette',
  'retur',
  'reval',
  'revir',
  'revle',
  'revne',
  'rhode',
  'ribbe',
  'rifle',
  'rigel',
  'rigge',
  'rigid',
  'rigor',
  'riing',
  'riise',
  'rijal',
  'rikke',
  'rikle',
  'rikse',
  'rikte',
  'rille',
  'rimer',
  'rimet',
  'ringe',
  'rinne',
  'ripet',
  'rippe',
  'riske',
  'risle',
  'rispe',
  'rissa',
  'risse',
  'riste',
  'ritsj',
  'ritus',
  'rival',
  'river',
  'roald',
  'robbe',
  'robot',
  'rocka',
  'rocke',
  'rocky',
  'rodal',
  'rodel',
  'rodeo',
  'rodos',
  'roger',
  'rogne',
  'roing',
  'rokke',
  'rolex',
  'rolig',
  'rolle',
  'roman',
  'rombe',
  'romeo',
  'romer',
  'romme',
  'rompe',
  'rondo',
  'rorbu',
  'rosen',
  'roset',
  'rosin',
  'rosse',
  'roste',
  'roter',
  'rotet',
  'rotor',
  'rotte',
  'rotur',
  'rouen',
  'rouge',
  'rough',
  'rover',
  'rubbe',
  'rubel',
  'rubin',
  'ruffe',
  'rufse',
  'rugby',
  'rugde',
  'ruger',
  'rugge',
  'rugle',
  'ruing',
  'rukke',
  'rukle',
  'rulle',
  'rulte',
  'rumba',
  'rumle',
  'rumpe',
  'runar',
  'runde',
  'rundt',
  'runge',
  'runke',
  'runne',
  'runse',
  'rural',
  'rushe',
  'ruske',
  'rusle',
  'ruste',
  'ruter',
  'rutet',
  'rutle',
  'rutte',
  'rydde',
  'rügen',
  'ryger',
  'rygge',
  'rying',
  'rykke',
  'rykte',
  'rynke',
  'rysje',
  'ryste',
  'rytme',
  'sabah',
  'sabbe',
  'sabel',
  'sabla',
  'sable',
  'sabra',
  'sadel',
  'sadle',
  'safir',
  'safte',
  'sagan',
  'sager',
  'sagmo',
  'sahib',
  'saiga',
  'saima',
  'saint',
  'sakke',
  'sakne',
  'sakse',
  'sakte',
  'salat',
  'saldo',
  'salet',
  'salig',
  'saliv',
  'salme',
  'salsa',
  'salte',
  'salto',
  'salve',
  'salvo',
  'samba',
  'sambo',
  'sambu',
  'samle',
  'samme',
  'samoa',
  'samos',
  'samse',
  'sande',
  'sanke',
  'sankt',
  'sanne',
  'sanse',
  'santa',
  'santo',
  'sappe',
  'sarah',
  'satan',
  'satse',
  'satyr',
  'saual',
  'sauda',
  'saudi',
  'sauna',
  'sause',
  'saute',
  'savle',
  'savne',
  'scene',
  'schau',
  'schei',
  'scoop',
  'score',
  'scott',
  'seato',
  'sebra',
  'sedan',
  'sedat',
  'seder',
  'seede',
  'sefyr',
  'segle',
  'segne',
  'seide',
  'seier',
  'seife',
  'seile',
  'seing',
  'seipe',
  'seire',
  'seise',
  'sekel',
  'seksa',
  'sekst',
  'selbu',
  'selen',
  'selge',
  'selje',
  'sella',
  'selle',
  'selma',
  'selot',
  'selve',
  'semin',
  'semje',
  'senat',
  'sende',
  'senet',
  'senil',
  'senit',
  'senja',
  'senke',
  'senna',
  'señor',
  'seoul',
  'sepia',
  'sepoy',
  'seraf',
  'serai',
  'serie',
  'serum',
  'serve',
  'sesam',
  'sesse',
  'seter',
  'setre',
  'sette',
  'sevje',
  'shake',
  'shelf',
  'shell',
  'short',
  'showe',
  'shunt',
  'sibir',
  'sidde',
  'siden',
  'sider',
  'sigar',
  'sigen',
  'sigge',
  'sigma',
  'signe',
  'sigri',
  'siing',
  'sikle',
  'sikre',
  'sikte',
  'silde',
  'silje',
  'silke',
  'silur',
  'simen',
  'simle',
  'simon',
  'simpe',
  'sinai',
  'sinke',
  'sinna',
  'sinne',
  'sinus',
  'sioux',
  'sipet',
  'sippe',
  'sirat',
  'sirka',
  'sirup',
  'sisal',
  'sisel',
  'sisik',
  'sisle',
  'sitar',
  'sitat',
  'siter',
  'sitre',
  'sitte',
  'situp',
  'sivil',
  'sjakk',
  'sjako',
  'sjakt',
  'sjalu',
  'sjapp',
  'sjark',
  'sjarm',
  'sjask',
  'sjaue',
  'sjefe',
  'sjeik',
  'sjekk',
  'sjete',
  'sjikt',
  'sjoge',
  'sjogs',
  'sjokk',
  'sjuer',
  'sjuke',
  'sjusk',
  'skabb',
  'skade',
  'skaft',
  'skage',
  'skake',
  'skakk',
  'skala',
  'skald',
  'skalk',
  'skall',
  'skalp',
  'skank',
  'skann',
  'skant',
  'skape',
  'skare',
  'skark',
  'skarn',
  'skarp',
  'skarv',
  'skate',
  'skatt',
  'skaug',
  'skaun',
  'skaut',
  'skave',
  'skavl',
  'skeet',
  'skeid',
  'skeie',
  'skeis',
  'skeiv',
  'skien',
  'skift',
  'skikk',
  'skill',
  'skilt',
  'skimt',
  'skinn',
  'skipe',
  'skipp',
  'skire',
  'skita',
  'skite',
  'skitt',
  'skive',
  'skjen',
  'skjev',
  'skjor',
  'skjul',
  'sklie',
  'skoda',
  'skoft',
  'skogn',
  'skokk',
  'skole',
  'skolm',
  'skolp',
  'skolt',
  'skore',
  'skort',
  'skose',
  'skott',
  'skove',
  'skovl',
  'skral',
  'skrap',
  'skred',
  'skrei',
  'skrev',
  'skrie',
  'skrik',
  'skrin',
  'skriv',
  'skrog',
  'skrot',
  'skrov',
  'skrud',
  'skrue',
  'skruv',
  'skryt',
  'skubb',
  'skudd',
  'skuff',
  'skule',
  'skulk',
  'skuls',
  'skump',
  'skunk',
  'skurd',
  'skure',
  'skurk',
  'skurv',
  'skute',
  'skutt',
  'skval',
  'skvip',
  'skvis',
  'skyet',
  'skygg',
  'skyld',
  'skyll',
  'skyru',
  'skyss',
  'skyte',
  'skyts',
  'skyve',
  'skaar',
  'slabb',
  'sladd',
  'slafs',
  'slage',
  'slagg',
  'slags',
  'slakk',
  'slakt',
  'slamp',
  'slams',
  'slang',
  'slank',
  'slant',
  'slapp',
  'slaps',
  'slark',
  'slarv',
  'slask',
  'slaur',
  'slede',
  'sleid',
  'sleik',
  'sleip',
  'sleis',
  'sleiv',
  'slekt',
  'sleng',
  'slepe',
  'slepp',
  'slesk',
  'slett',
  'sleve',
  'slide',
  'slikk',
  'slikt',
  'slime',
  'slind',
  'slipe',
  'slipp',
  'slips',
  'slire',
  'slisk',
  'slite',
  'slitt',
  'sliul',
  'slodd',
  'slott',
  'sludd',
  'slufs',
  'sluke',
  'slukt',
  'slump',
  'slums',
  'slupp',
  'slups',
  'slure',
  'slurk',
  'slurp',
  'slurv',
  'sluse',
  'slusk',
  'slutt',
  'slyet',
  'slyng',
  'smake',
  'smale',
  'smart',
  'smash',
  'smask',
  'smatt',
  'smede',
  'smeik',
  'smeis',
  'smekk',
  'smell',
  'smikk',
  'smile',
  'smisk',
  'smith',
  'smitt',
  'smokk',
  'smolt',
  'smudi',
  'smukk',
  'smule',
  'smult',
  'smurf',
  'smuss',
  'smutt',
  'smyge',
  'smyle',
  'snabb',
  'snadd',
  'snafs',
  'snake',
  'snakk',
  'snaks',
  'snapp',
  'snaps',
  'snare',
  'snarp',
  'snart',
  'snask',
  'snaue',
  'snavl',
  'snegl',
  'sneie',
  'sneip',
  'sneis',
  'sneke',
  'snell',
  'snerk',
  'snerp',
  'snerr',
  'snert',
  'snike',
  'snile',
  'snill',
  'snipe',
  'snipp',
  'snitt',
  'snive',
  'snobb',
  'snoke',
  'snope',
  'snork',
  'snott',
  'snufs',
  'snuft',
  'snupp',
  'snupt',
  'snurp',
  'snurr',
  'snurt',
  'snuse',
  'snusk',
  'snute',
  'snutt',
  'snyta',
  'snyte',
  'snytt',
  'soare',
  'sobel',
  'sober',
  'sofia',
  'sofie',
  'sogne',
  'sokke',
  'sokne',
  'solar',
  'solem',
  'solid',
  'solum',
  'solur',
  'somle',
  'somme',
  'sonar',
  'sonde',
  'sonja',
  'sonor',
  'sopen',
  'soper',
  'soppe',
  'sorbe',
  'soria',
  'sorry',
  'sorti',
  'soset',
  'sotet',
  'sotra',
  'sound',
  'south',
  'sover',
  'sovne',
  'spade',
  'spain',
  'spane',
  'spann',
  'spant',
  'spare',
  'spark',
  'spase',
  'spatt',
  'speed',
  'speil',
  'speke',
  'spekk',
  'speks',
  'spell',
  'spelt',
  'spene',
  'spenn',
  'spent',
  'spett',
  'spidd',
  'spika',
  'spike',
  'spikk',
  'spile',
  'spill',
  'spink',
  'spinn',
  'spion',
  'spire',
  'spise',
  'spisk',
  'spiss',
  'splid',
  'spole',
  'spong',
  'spord',
  'spore',
  'sport',
  'spott',
  'spove',
  'sprak',
  'spray',
  'sprek',
  'sprik',
  'sprit',
  'sprog',
  'sprut',
  'spryd',
  'spuns',
  'spurt',
  'spurv',
  'spyle',
  'spytt',
  'squaw',
  'stade',
  'stage',
  'stake',
  'stakk',
  'stall',
  'stamp',
  'stand',
  'stane',
  'stang',
  'stank',
  'stans',
  'stapp',
  'stare',
  'starr',
  'start',
  'stase',
  'stasi',
  'staup',
  'staur',
  'staut',
  'stave',
  'stavn',
  'steam',
  'stede',
  'steen',
  'stege',
  'stegg',
  'steik',
  'steil',
  'stein',
  'steke',
  'stekk',
  'stele',
  'stell',
  'stene',
  'steng',
  'stenk',
  'sterk',
  'stett',
  'stevn',
  'stian',
  'stift',
  'stige',
  'stikk',
  'stile',
  'stilk',
  'still',
  'stime',
  'stine',
  'sting',
  'stinn',
  'stirr',
  'stive',
  'stode',
  'stoff',
  'stogg',
  'stokk',
  'stola',
  'stole',
  'stoll',
  'stolt',
  'stomp',
  'stopp',
  'stora',
  'stord',
  'stork',
  'storm',
  'story',
  'stove',
  'strak',
  'stram',
  'strek',
  'strev',
  'strid',
  'strie',
  'stril',
  'strut',
  'stryk',
  'stryn',
  'stubb',
  'stuer',
  'stuke',
  'stukk',
  'stull',
  'stump',
  'stund',
  'stunt',
  'stupa',
  'stupe',
  'sture',
  'stuss',
  'stutt',
  'stygg',
  'stykk',
  'style',
  'styre',
  'styrt',
  'subbe',
  'subus',
  'sudan',
  'sugen',
  'suger',
  'sugge',
  'suite',
  'sukat',
  'sukke',
  'sukle',
  'sukre',
  'sulke',
  'sulky',
  'sulle',
  'sulre',
  'sulte',
  'sumak',
  'summe',
  'sunde',
  'sundt',
  'sunna',
  'sunni',
  'suomi',
  'super',
  'suppe',
  'surfe',
  'surle',
  'surna',
  'surne',
  'surre',
  'suser',
  'suset',
  'sushi',
  'susle',
  'susse',
  'sutre',
  'sutte',
  'sutur',
  'svada',
  'svage',
  'svaie',
  'svale',
  'svamp',
  'svane',
  'svang',
  'svans',
  'svare',
  'svart',
  'svarv',
  'svear',
  'sveen',
  'sveig',
  'svein',
  'sveio',
  'sveip',
  'sveis',
  'sveit',
  'sveiv',
  'svekk',
  'svele',
  'svelg',
  'svell',
  'svend',
  'svenn',
  'svepe',
  'sverd',
  'sverm',
  'svett',
  'sveum',
  'sveve',
  'svike',
  'svikt',
  'svill',
  'svime',
  'svine',
  'sving',
  'svinn',
  'svint',
  'svipe',
  'svipp',
  'svire',
  'svive',
  'svolk',
  'svull',
  'svupp',
  'swazi',
  'swing',
  'syden',
  'sying',
  'sykle',
  'sykne',
  'sylfe',
  'sylta',
  'sylte',
  'symre',
  'synde',
  'synes',
  'synge',
  'synke',
  'synne',
  'synse',
  'synsk',
  'syrer',
  'syria',
  'syrin',
  'syrne',
  'sysle',
  'syten',
  'syter',
  'sytet',
  'sytti',
  'syver',
  'saana',
  'tabbe',
  'tafse',
  'tagal',
  'tagge',
  'tagne',
  'taiga',
  'taime',
  'takke',
  'takle',
  'takse',
  'takst',
  'taler',
  'talge',
  'talje',
  'talle',
  'tally',
  'tamil',
  'tampe',
  'tamse',
  'tanga',
  'tange',
  'tango',
  'tanke',
  'tanks',
  'tanne',
  'tante',
  'tapas',
  'taper',
  'tapet',
  'tapir',
  'tappe',
  'tarve',
  'tasal',
  'taset',
  'taske',
  'tasle',
  'tasse',
  'taste',
  'tatar',
  'tater',
  'tatle',
  'tatra',
  'taube',
  'tauer',
  'tavle',
  'tchad',
  'teddy',
  'tefat',
  'tefte',
  'tegne',
  'tehus',
  'teine',
  'teing',
  'teint',
  'teipe',
  'teist',
  'teite',
  'tekke',
  'tekno',
  'tekst',
  'telet',
  'telle',
  'telne',
  'telte',
  'telys',
  'temme',
  'tempo',
  'tenar',
  'tenke',
  'tenne',
  'tenor',
  'teori',
  'teppe',
  'terge',
  'terje',
  'terme',
  'terne',
  'terpe',
  'terra',
  'terse',
  'terte',
  'tesil',
  'tesla',
  'teste',
  'tetne',
  'tette',
  'tevle',
  'texas',
  'thora',
  'thore',
  'thorn',
  'thune',
  'tiara',
  'tibet',
  'tidel',
  'tidig',
  'tiern',
  'tiger',
  'tigge',
  'tiing',
  'tikke',
  'tilbe',
  'tilby',
  'tilde',
  'tilgi',
  'tilje',
  'tille',
  'tilse',
  'tilsi',
  'tilta',
  'tilte',
  'times',
  'timid',
  'tinde',
  'tiner',
  'tinge',
  'tinne',
  'tinte',
  'tiple',
  'tippe',
  'tipse',
  'tirre',
  'tiske',
  'tisle',
  'tispe',
  'titan',
  'titid',
  'titte',
  'tjafs',
  'tjalk',
  'tjatt',
  'tjeld',
  'tjene',
  'tjern',
  'tjone',
  'tjore',
  'tjukk',
  'tjukn',
  'tjuve',
  'toast',
  'tobbe',
  'tobis',
  'toddi',
  'toddy',
  'toene',
  'tofte',
  'toing',
  'tokar',
  'tokke',
  'tokte',
  'tokyo',
  'tolar',
  'tolga',
  'tolke',
  'tolle',
  'tomas',
  'tomat',
  'tomme',
  'tomse',
  'tomte',
  'tonal',
  'tonem',
  'tonus',
  'topas',
  'toppe',
  'toril',
  'torpa',
  'torpo',
  'torsk',
  'torso',
  'torun',
  'torve',
  'tosse',
  'total',
  'totem',
  'toten',
  'totid',
  'touch',
  'toven',
  'tovet',
  'trabi',
  'trace',
  'trade',
  'trafo',
  'trake',
  'trakk',
  'trakt',
  'trale',
  'trall',
  'tralt',
  'tramp',
  'trane',
  'trang',
  'trant',
  'trapp',
  'trase',
  'trask',
  'trass',
  'traud',
  'trave',
  'treak',
  'trede',
  'treen',
  'treer',
  'treet',
  'treff',
  'trege',
  'treig',
  'trekk',
  'trekt',
  'trell',
  'trema',
  'trend',
  'trene',
  'tresk',
  'tress',
  'trett',
  'treve',
  'trevl',
  'trial',
  'trias',
  'trick',
  'trikk',
  'triks',
  'trill',
  'trine',
  'trinn',
  'triol',
  'tripp',
  'trips',
  'trise',
  'trist',
  'tritt',
  'trive',
  'trofe',
  'troke',
  'troll',
  'troms',
  'trond',
  'trone',
  'tronn',
  'trope',
  'tropp',
  'tross',
  'trost',
  'truck',
  'trude',
  'truen',
  'truge',
  'truls',
  'trumf',
  'trump',
  'trunk',
  'trupp',
  'truse',
  'trust',
  'trutt',
  'trygd',
  'trygg',
  'trykk',
  'trykt',
  'tryne',
  'tryte',
  'tuete',
  'tufse',
  'tufte',
  'tugge',
  'tukan',
  'tukle',
  'tukte',
  'tulle',
  'tulsa',
  'tumle',
  'tumor',
  'tuner',
  'tunge',
  'tunis',
  'tuppe',
  'turbo',
  'turid',
  'turku',
  'turne',
  'turve',
  'tusen',
  'tusje',
  'tuske',
  'tusle',
  'tusse',
  'tuste',
  'tutel',
  'tutle',
  'tutor',
  'tutsi',
  'tutte',
  'tutti',
  'tuvet',
  'tvang',
  'tvare',
  'tvebo',
  'tvebu',
  'tvedt',
  'tveit',
  'tverr',
  'tvers',
  'tvert',
  'tvett',
  'tvile',
  'tvill',
  'tvinn',
  'tvist',
  'tweed',
  'twist',
  'tydal',
  'tyder',
  'tyfon',
  'tyfus',
  'tygge',
  'tying',
  'tykke',
  'tykne',
  'tylft',
  'tylle',
  'tymus',
  'tynge',
  'tynne',
  'typus',
  'tyrol',
  'tysse',
  'tyste',
  'tytte',
  'tyved',
  'tyvjo',
  'uanet',
  'ubedt',
  'ubest',
  'ublid',
  'ublyg',
  'ubona',
  'ubont',
  'ubygd',
  'udekt',
  'udelt',
  'udryg',
  'uedel',
  'uegna',
  'uekte',
  'uenig',
  'ufiks',
  'ufisk',
  'ufora',
  'ufred',
  'ufset',
  'ufyse',
  'ugagn',
  'uggen',
  'ugget',
  'ugift',
  'ugild',
  'uglad',
  'ugras',
  'ugrei',
  'ugrer',
  'uheil',
  'uhell',
  'uhuga',
  'uhyre',
  'ujamn',
  'ujevn',
  'uklar',
  'uklok',
  'ukokt',
  'ukysk',
  'ulada',
  'uladd',
  'ulage',
  'ulest',
  'ulevd',
  'ulike',
  'uling',
  'ullen',
  'ullus',
  'ulrik',
  'ulvik',
  'ulyst',
  'umake',
  'umalt',
  'umbra',
  'umiak',
  'umild',
  'ummah',
  'unavn',
  'undas',
  'under',
  'undre',
  'unett',
  'union',
  'unnbe',
  'unnse',
  'unnsi',
  'unnta',
  'unote',
  'upara',
  'upopp',
  'upris',
  'uraka',
  'urban',
  'urdyr',
  'uredd',
  'urede',
  'ureid',
  'urein',
  'uremi',
  'urete',
  'urett',
  'urtid',
  'urund',
  'urven',
  'usagt',
  'usamd',
  'usams',
  'usann',
  'usbek',
  'usett',
  'usexy',
  'uskap',
  'usmak',
  'usona',
  'usont',
  'ussel',
  'usunn',
  'usydd',
  'usyra',
  'usyrt',
  'utakk',
  'utakt',
  'utall',
  'utarm',
  'utarv',
  'utasa',
  'utast',
  'utbre',
  'utbud',
  'utedo',
  'utekk',
  'utemt',
  'utett',
  'utfor',
  'utfri',
  'uthus',
  'utina',
  'uting',
  'utint',
  'utkik',
  'utkok',
  'utleg',
  'utlyd',
  'utmed',
  'utoen',
  'utopi',
  'utrop',
  'utror',
  'utsig',
  'utsyn',
  'uttak',
  'uttog',
  'uttur',
  'utukt',
  'utved',
  'utveg',
  'utvei',
  'utysk',
  'uvane',
  'uvant',
  'uvdal',
  'uvenn',
  'uvett',
  'uviss',
  'vabbe',
  'vable',
  'vader',
  'vadre',
  'vaduz',
  'vafle',
  'vagge',
  'vagle',
  'vaier',
  'vaing',
  'vaken',
  'vaker',
  'vakle',
  'vakne',
  'vakte',
  'valen',
  'valid',
  'valke',
  'valle',
  'valma',
  'valme',
  'valne',
  'valpe',
  'valse',
  'valte',
  'vande',
  'vange',
  'vanke',
  'vanne',
  'vanry',
  'vante',
  'varde',
  'varia',
  'varig',
  'varme',
  'varpe',
  'varte',
  'vaset',
  'vaske',
  'vasle',
  'vasse',
  'vater',
  'vatne',
  'vatre',
  'vavre',
  'vebbe',
  'vedbu',
  'vedda',
  'vedde',
  'vedta',
  'vefsn',
  'vefte',
  'vegan',
  'vegas',
  'vegne',
  'vegre',
  'veide',
  'veidn',
  'veier',
  'veike',
  'veile',
  'veite',
  'veive',
  'vekke',
  'vekne',
  'vekst',
  'vekta',
  'vekte',
  'velar',
  'velde',
  'velge',
  'velin',
  'velle',
  'velsk',
  'velte',
  'velum',
  'velur',
  'vemod',
  'vende',
  'venne',
  'vente',
  'verde',
  'verdi',
  'verdt',
  'verft',
  'verge',
  'verke',
  'verne',
  'verpe',
  'verre',
  'verst',
  'verve',
  'vesal',
  'vesel',
  'vesen',
  'vesir',
  'veske',
  'vesla',
  'vesle',
  'vesta',
  'vesuv',
  'vette',
  'vever',
  'vichy',
  'vidar',
  'vidde',
  'viden',
  'video',
  'vidje',
  'vifer',
  'vifte',
  'vigge',
  'viggo',
  'vigil',
  'vigle',
  'vigra',
  'viing',
  'vikan',
  'vikar',
  'viker',
  'vikke',
  'vikle',
  'vikna',
  'viksk',
  'vikte',
  'vilje',
  'villa',
  'ville',
  'vimen',
  'vimet',
  'vimre',
  'vimse',
  'vinby',
  'vinde',
  'vindu',
  'vinga',
  'vinge',
  'vinje',
  'vinke',
  'vinne',
  'vinsj',
  'vinst',
  'vinyl',
  'vippe',
  'vipse',
  'virak',
  'viral',
  'viril',
  'virke',
  'virre',
  'virus',
  'viser',
  'visir',
  'viske',
  'visle',
  'visne',
  'vispe',
  'visse',
  'visst',
  'vista',
  'visum',
  'vital',
  'viten',
  'vitje',
  'vitne',
  'vitre',
  'vitse',
  'vivat',
  'vodka',
  'voffe',
  'vogge',
  'voile',
  'vokal',
  'vokke',
  'vokse',
  'vokte',
  'volda',
  'volde',
  'volga',
  'volle',
  'volta',
  'volte',
  'volum',
  'volve',
  'volvo',
  'vonom',
  'vorde',
  'vorma',
  'vorte',
  'votum',
  'vovet',
  'vrake',
  'vrang',
  'vrede',
  'vrien',
  'vrier',
  'vrikk',
  'vrist',
  'vugge',
  'vulke',
  'vulst',
  'vulva',
  'vaasa',
  'wales',
  'walle',
  'wanda',
  'water',
  'watne',
  'webbe',
  'weber',
  'whist',
  'white',
  'wiggo',
  'willy',
  'wokke',
  'worth',
  'waage',
  'xenie',
  'xenon',
  'yacht',
  'yatzy',
  'ydmyk',
  'yemen',
  'yling',
  'ynder',
  'yndig',
  'yngel',
  'ynges',
  'yngle',
  'yngre',
  'yngve',
  'ynkes',
  'yppal',
  'yppig',
  'yrete',
  'yrhet',
  'yring',
  'ystad',
  'ystel',
  'yster',
  'yting',
  'yukon',
  'zaire',
  'zappe',
  'zloty',
  'zoome',
]
